'use client'
import { useMemo } from 'react'

import {
    Button,
    type ButtonProps,
    DownloadTitles,
    Hidden,
    useDownloadProps,
} from '@doist/marketist'

import cn from 'clsx'
import { BigButton } from 'components/big-button/big-button'
import { useTranslation } from 'next-i18next'
import { registerUrl } from 'services/authUrls'

import type { OmitKnown } from 'types'

type GetStartedButtonProps = {
    text?: string
    className?: string
    mobileButtonTitle?: DownloadTitles
    size?: 'small' | 'base' | 'large' | 'xl'
    authenticatedLabel?: string
}

export default function GetStartedButton({
    text,
    className,
    mobileButtonTitle,
    size = 'large',
    ...rest
}: GetStartedButtonProps) {
    const { t } = useTranslation('common')
    const titles = useMemo(() => {
        return mobileButtonTitle
            ? mobileButtonTitle
            : new DownloadTitles(
                  t('startForFree'),
                  t('startForFree'),
                  t('startForFree'),
                  t('startForFree'),
                  t('startForFree'),
                  t('startForFree'),
              )
    }, [mobileButtonTitle, t])
    const { href } = useDownloadProps(titles)

    return (
        <span>
            {/* Desktop: display "Get Started" */}
            <Hidden below="md">
                {size === 'xl' ? (
                    <BigButton
                        className={cn('ga-get-started-button', className)}
                        href={registerUrl}
                        {...rest}
                    >
                        {t('startForFree')}
                    </BigButton>
                ) : (
                    <Button
                        size={size}
                        className={cn('ga-get-started-button', className)}
                        href={registerUrl}
                        {...rest}
                    >
                        {t('startForFree')}
                    </Button>
                )}
            </Hidden>

            {/* Mobile: display download button */}
            <Hidden above="md">
                {size === 'xl' ? (
                    <BigButton href={href} className={className}>
                        {t('startForFree')}
                    </BigButton>
                ) : (
                    <Button href={href} size={size} className={className}>
                        {t('startForFree')}
                    </Button>
                )}
            </Hidden>
        </span>
    )
}

type GetStartedButtonSimpleProps = OmitKnown<ButtonProps, 'href' | 'children'>

export function GetStartedButtonSimple({
    size,
    variant = 'primary',
    ...props
}: GetStartedButtonSimpleProps) {
    const { t } = useTranslation('common')

    return (
        <>
            {size === 'xl' ? (
                <BigButton href={registerUrl} {...props}>
                    {t('startForFree')}
                </BigButton>
            ) : variant !== 'quinary' ? (
                <Button variant={variant} href={registerUrl} {...props}>
                    {t('startForFree')}
                </Button>
            ) : null}
        </>
    )
}
